import { createUseStyles } from 'react-jss';

import { color, fontSize } from '../../variables';

export const useButtonSecondaryStyle = createUseStyles({
    root: {
        fontSize: fontSize.sm,
        color: color.content.primary,
        fontWeight: 600,
        background: `${color.background.primary} !important`,
        borderRadius: 4,

        '&:hover': {
            background: `${color.background.primary} !important`,
            borderColor: `${color.border.opaque} !important`,
            color: `${color.content.primary} !important`,
            opacity: 0.85,
        },
        '&:active': {
            background: color.background.primary,
            border: `3px solid ${color.border.accent} !important`,
            color: `${color.content.primary} !important`,
        },
        '&:disabled': {
            background: color.background.disabled,
            borderColor: `${color.border.inverseOpaque} !important`,
            color: `${color.content.stateDisable} !important`,
        },
    },
});
